// @charset "utf-8";
const levelType = function (type) {
    switch (Number(type)) {
    case 1:
        return 'level1'
    case 2:
        return 'level2'
    case 3:
        return 'level3'
    case 4:
        return 'level4'
    default:
        return '--'
    }
}

const character = function (type) {
    switch (Number(type)) {
    case 1:
        return 'radical'
    case 2:
        return 'positive'
    case 3:
    case 4:
        return 'steady'
        // return 'conservative'
    default:
        return '--'
    }
}

const safeNumber = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num)
}

const safeIntegerNumber = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(0)
}

const safeFloatFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2)
}

const safeFloatPerFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2) + '%'
}

const safePercentFixedTwo = function (num) {
    if (num === null) {
        return '--'
    }
    return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%'
}

const riseAndFallClass = function (num, standard) {
    if (isNaN(num)) {
        return ''
    }
    if (!standard) {
        standard = 0
    }
    return Number(num) > standard ? 'rise-red' : (Number(num) < standard ? 'fall-green' : '')
}

const eventNumberFixed = function (num) {
    if (Number(num) === -1) {
        return '--'
    } else if (Number(num) > -10 && Number(num) < 10) {
        return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%'
    } else {
        return num
    }
}

const eventFallClass = function (num, standard) {
    if (Number(num) === -1) {
        return ''
    } else if (Number(num) > -10 && Number(num) < 10) {
        if (isNaN(num)) {
            return ''
        }
        if (!standard) {
            standard = 0
        }
        return Number(num) > standard ? 'rise-red' : (Number(num) < standard ? 'fall-green' : '')
    } else {
        return ''
    }
}

const limitlength = function (num) {
    if (Number(num) <= 200) {
        return Number(num)
    } else {
        return 200
    }
}

const changeDateVal = function (date) {
    if (date === undefined) {
        return '--'
    }
    return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6)
}

const slicetwo = function (data) {
    return String(data).substring(0, 6)
}

export {
    levelType,
    character,
    safeNumber,
    safeIntegerNumber,
    safeFloatFixedTwo,
    safeFloatPerFixedTwo,
    safePercentFixedTwo,
    riseAndFallClass,
    limitlength,
    eventNumberFixed,
    eventFallClass,
    changeDateVal,
    slicetwo
}



// WEBPACK FOOTER //
// ./src/filters/index.js